import m from "../../../../geodata/es2015/region/usa/vaHigh";
window.am4geodata_region_usa_vaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/vaHigh.js
// module id = null
// module chunks = 